// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2xlx5","alertIcon":"ConfirmModal_alertIcon__26kp3"};